<template>
  <div
    class="bg-cool-gray-50 py-4 px-4 overflow-hidden sm:px-6 lg:px-8 lg:py-12"
    v-if="page == 1 "
  >
    <div class="relative max-w-xl mx-auto">
      <div class="mb-4">
        <img
          class="object-cover object-center rounded justify-center mx-auto w-48 mb-4"
          alt="hero"
          src=".././assets/ccme-logo.png"
        />
        <h3
          class="text-xl leading-9 tracking-tight font-bold text-primary-900 sm:text-3xl sm:leading-10 text-center"
        >
          تسجيل النّاخبين
        </h3>
      </div>

      <dl
        v-if="!success"
        class="pt-4   sm:space-y-0 sm:grid sm:grid-cols-1 sm:col-gap-6 sm:row-gap-4 lg:grid-cols-1 lg:col-gap-2"
      >
        <div class="flex flex-col space-x-3 space-x-reverse">
          <h3 class="text-lg leading-6 font-medium text-gray-900">
            شروط التسجيل
          </h3>

          <p class="my-2 max-w-2xl text-sm leading-5 text-gray-500">
            للتسجيل في الانتخابات البلدية يجب أن تنطبق عليك الشروط الآتية:
          </p>
        </div>
        <div class="flex space-x-3 space-x-reverse">
          <!-- Heroicon name: check -->
          <svg
            class="flex-shrink-0 h-6 w-6 text-blue-400"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
          <div class="space-y-2">
            <dt class="text-lg leading-6 font-medium text-gray-900">
              أن يكون ليبي الجنسية متمتعا بكامل حقوقه المدنية.
            </dt>
          </div>
        </div>
        <div class="flex space-x-3 space-x-reverse">
          <!-- Heroicon name: check -->
          <svg
            class="flex-shrink-0 h-6 w-6 text-blue-400"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
          <div class="space-y-2">
            <dt class="text-lg leading-6 font-medium text-gray-900">
              أن يكون كامل الأهلية و قد أتم
              <span class="systemfont"> (18)</span> سنة من عمره أثناء التسجيل.
            </dt>
          </div>
        </div>
        <div class="flex space-x-3 space-x-reverse">
          <!-- Heroicon name: check -->
          <svg
            class="flex-shrink-0 h-6 w-6 text-blue-400"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
          <div class="space-y-2">
            <dt class="text-lg leading-6 font-medium text-gray-900">
              أن يكون مقيم ومقيد او مقيم وغير مقيد داخل نطاق الجغرافي للبلدية.
            </dt>
          </div>
        </div>

        <div class="flex space-x-3 space-x-reverse">
          <!-- Heroicon name: check -->
          <svg
            class="flex-shrink-0 h-6 w-6 text-blue-400"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
          <div class="space-y-2">
            <dt class="text-lg leading-6 font-medium text-gray-900">
              الا يكون قد مارس حقه في انتخاب مجلس بلدي في نفس الدورة الانتخابية.
            </dt>
          </div>
        </div>
      </dl>

      <div class="text-center text-xl mt-6">
        للإستفســار اضغط على

        <p class="systemfont font-bold mt-3" dir="ltr">
          <a href="tel:0920407200">092 040 72 00</a>
        </p>
        <p class="systemfont font-bold" dir="ltr">
          <a href="tel:0910407200">091 040 72 00</a>
        </p>

        <div class="flex content-center mx-20 md:mx-20 lg:mx-36 my-6">
          <a
            href="https://api.whatsapp.com/send?phone=+218920407200"
            class="m-auto"
          >
            <svg
              class="m-auto"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 48 48"
              width="48px"
              height="48px"
              fill-rule="evenodd"
              clip-rule="evenodd"
            >
              <path
                fill="#fff"
                d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"
              />
              <path
                fill="#fff"
                d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"
              />
              <path
                fill="#cfd8dc"
                d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"
              />
              <path
                fill="#40c351"
                d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"
              />
              <path
                fill="#fff"
                fill-rule="evenodd"
                d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z"
                clip-rule="evenodd"
              /></svg
          ></a>
          <a href="https://t.me/+218920407200" class="m-auto">
            <svg
              class="m-auto"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 48 48"
              width="48px"
              height="48px"
            >
              <path
                fill="#29b6f6"
                d="M24 4A20 20 0 1 0 24 44A20 20 0 1 0 24 4Z"
              />
              <path
                fill="#fff"
                d="M33.95,15l-3.746,19.126c0,0-0.161,0.874-1.245,0.874c-0.576,0-0.873-0.274-0.873-0.274l-8.114-6.733 l-3.97-2.001l-5.095-1.355c0,0-0.907-0.262-0.907-1.012c0-0.625,0.933-0.923,0.933-0.923l21.316-8.468 c-0.001-0.001,0.651-0.235,1.126-0.234C33.667,14,34,14.125,34,14.5C34,14.75,33.95,15,33.95,15z"
              />
              <path
                fill="#b0bec5"
                d="M23,30.505l-3.426,3.374c0,0-0.149,0.115-0.348,0.12c-0.069,0.002-0.143-0.009-0.219-0.043 l0.964-5.965L23,30.505z"
              />
              <path
                fill="#cfd8dc"
                d="M29.897,18.196c-0.169-0.22-0.481-0.26-0.701-0.093L16,26c0,0,2.106,5.892,2.427,6.912 c0.322,1.021,0.58,1.045,0.58,1.045l0.964-5.965l9.832-9.096C30.023,18.729,30.064,18.416,29.897,18.196z"
              />
            </svg>
          </a>
          <a href="viber://contact?number=%2B218920407200" class="m-auto">
            <svg
              class="m-auto"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 48 48"
              width="48px"
              height="48px"
            >
              <path
                fill="#fff"
                d="M24,5C21.361,5,13.33,5,8.89,9.054C6.246,11.688,5,15.494,5,21v3c0,5.506,1.246,9.312,3.921,11.976 c1.332,1.215,3.148,2.186,5.368,2.857L15,39.047v5.328C15,45,15.181,45,15.241,45c0.123,0,0.32-0.039,0.694-0.371 c0.09-0.089,0.75-0.803,3.96-4.399l0.324-0.363l0.485,0.031C21.779,39.965,22.888,40,24,40c2.639,0,10.67,0,15.11-4.055 C41.753,33.311,43,29.505,43,24v-3c0-5.506-1.246-9.312-3.921-11.976C34.67,5,26.639,5,24,5z"
              />
              <path
                fill="#7e57c2"
                d="M33.451 28.854c-1.111-.936-1.624-1.219-3.158-2.14C29.654 26.331 28.68 26 28.169 26c-.349 0-.767.267-1.023.523C26.49 27.179 26.275 28 25.125 28c-1.125 0-3.09-1.145-4.5-2.625C19.145 23.965 18 22 18 20.875c0-1.15.806-1.38 1.462-2.037C19.718 18.583 20 18.165 20 17.816c0-.511-.331-1.47-.714-2.109-.921-1.535-1.203-2.048-2.14-3.158-.317-.376-.678-.548-1.056-.549-.639-.001-1.478.316-2.046.739-.854.637-1.747 1.504-1.986 2.584-.032.147-.051.295-.057.443-.046 1.125.396 2.267.873 3.234 1.123 2.279 2.609 4.485 4.226 6.455.517.63 1.08 1.216 1.663 1.782.566.582 1.152 1.145 1.782 1.663 1.97 1.617 4.176 3.103 6.455 4.226.958.472 2.086.906 3.2.874.159-.005.318-.023.477-.058 1.08-.238 1.947-1.132 2.584-1.986.423-.568.74-1.406.739-2.046C33.999 29.532 33.827 29.171 33.451 28.854zM34 24c-.552 0-1-.448-1-1v-1c0-4.962-4.038-9-9-9-.552 0-1-.448-1-1s.448-1 1-1c6.065 0 11 4.935 11 11v1C35 23.552 34.552 24 34 24zM27.858 22c-.444 0-.85-.298-.967-.748-.274-1.051-1.094-1.872-2.141-2.142-.535-.139-.856-.684-.718-1.219.138-.534.682-.855 1.219-.718 1.748.453 3.118 1.822 3.575 3.574.139.535-.181 1.08-.715 1.22C28.026 21.989 27.941 22 27.858 22z"
              />
              <path
                fill="#7e57c2"
                d="M31,23c-0.552,0-1-0.448-1-1c0-3.188-2.494-5.818-5.678-5.986c-0.552-0.029-0.975-0.5-0.946-1.051 c0.029-0.552,0.508-0.976,1.051-0.946C28.674,14.241,32,17.748,32,22C32,22.552,31.552,23,31,23z"
              />
              <path
                fill="#7e57c2"
                d="M24,4C19.5,4,12.488,4.414,8.216,8.316C5.196,11.323,4,15.541,4,21c0,0.452-0.002,0.956,0.002,1.5 C3.998,23.043,4,23.547,4,23.999c0,5.459,1.196,9.677,4.216,12.684c1.626,1.485,3.654,2.462,5.784,3.106v4.586 C14,45.971,15.049,46,15.241,46h0.009c0.494-0.002,0.921-0.244,1.349-0.624c0.161-0.143,2.02-2.215,4.042-4.481 C21.845,40.972,22.989,41,23.999,41c0,0,0,0,0,0s0,0,0,0c4.5,0,11.511-0.415,15.784-4.317c3.019-3.006,4.216-7.225,4.216-12.684 c0-0.452,0.002-0.956-0.002-1.5c0.004-0.544,0.002-1.047,0.002-1.5c0-5.459-1.196-9.677-4.216-12.684C35.511,4.414,28.5,4,24,4z M41,23.651l0,0.348c0,4.906-1.045,8.249-3.286,10.512C33.832,38,26.437,38,23.999,38c-0.742,0-1.946-0.001-3.367-0.1 C20.237,38.344,16,43.083,16,43.083V37.22c-2.104-0.505-4.183-1.333-5.714-2.708C8.045,32.248,7,28.905,7,23.999l0-0.348 c0-0.351-0.001-0.73,0.002-1.173C6.999,22.078,6.999,21.7,7,21.348L7,21c0-4.906,1.045-8.249,3.286-10.512 C14.167,6.999,21.563,6.999,24,6.999c2.437,0,9.832,0,13.713,3.489c2.242,2.263,3.286,5.606,3.286,10.512l0,0.348 c0,0.351,0.001,0.73-0.002,1.173C41,22.922,41,23.3,41,23.651z"
              />
            </svg>
          </a>
        </div>
      </div>

      <div class="pt-8 border-t-2 border-gray-300 mt-10">
        <ValidationObserver
          v-slot="{ handleSubmit,  invalid, failed }"
          v-if="!success"
        >
          <form
            @submit.prevent="handleSubmit(reviewpage)"
            class="grid grid-cols-1 row-gap-6 sm:grid-cols-4 sm:col-gap-8 text-right"
          >
            <div class="sm:col-span-4 mb-2">
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                بيانات الاقتراع
              </h3>
              <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-400">
                الرّجاء إدخال بيانات البلدية والمركز الانتخابي الذي تنوي
                الانتخاب فيه
              </p>
            </div>

            <div class="sm:col-span-4">
              <label
                for="package"
                class="block text-lg font-bold leading-5 text-gray-900"
                >البلدية</label
              >
              <ValidationProvider
                name="municipality"
                rules="required"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <select
                    id="type"
                    v-model="selectedmunicipality"
                    class="mt-1 form-select form-input block w-full pl-3 pr-10 py-3 px-4 text-lg leading-6 text-center border-gray-300 focus:outline-none focus:shadow-outline-primary focus:border-primary-300 sm:text-lg"
                    :class="{ ' border border-red-500': v.errors[0] }"
                  >
                    <option selected disabled :value="null">اختر</option>
                    <option
                      v-for="municipality in municipalities"
                      :key="municipality.id"
                      :value="municipality"
                      class="font-bold"
                    >
                      {{ municipality.name }}
                    </option>
                  </select>
                </div>
                <p
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                  v-if="v.errors[0] != null"
                >
                  {{ v.errors[0] }}ة
                </p>
              </ValidationProvider>
            </div>

            <div class="sm:col-span-4" v-if="selectedmunicipality">
              <label
                for="package"
                class="block text-lg font-bold leading-5 text-gray-900"
                >مركز الاقتراع</label
              >
              <ValidationProvider
                name="electionCenterNo"
                rules="required"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <select
                    v-model="info.electionCenterNo"
                    class="mt-1 systemfont font-bold form-select form-input block w-full pl-3 pr-10 py-3 px-4 text-lg leading-6 text-center border-gray-300 focus:outline-none focus:shadow-outline-primary focus:border-primary-300 sm:text-lg"
                    :class="{ ' border border-red-500': v.errors[0] }"
                  >
                    <option selected disabled :value="null">اختر</option>
                    <option
                      v-for="center in selectedmunicipality.election_centers"
                      :key="center.id"
                      :value="center.id"
                      class="font-bold systemfont"
                    >
                      {{ center.name }}
                      <span class="systemfont"  
                        >- منطقة {{ center.area_name }}
                      </span>
                    </option>
                  </select>
                </div>
                <p
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                >
                  {{ v.errors[0] }}
                </p>
              </ValidationProvider>
            </div>

            <div class="sm:col-span-4 pt-8 border-t-2 mt-1 mb-2">
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                البيانات الشخصية
              </h3>
              <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-400">
                لتأكيد الهوية و المصادقة على البيانات
              </p>
            </div>

            <div>
              <label
                for="first_name"
                class="block text-lg font-bold leading-5 text-gray-900"
                >الاسم الأوّل</label
              >
              <ValidationProvider
                name="firstName"
                rules="required|max:20|regex:^[\u0621-\u064A ]+$"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <input
               
                    v-model="info.firstName"
                    class="form-input py-3 px-4 block w-full transition ease-in-out duration-150"
                    :class="{ ' border border-red-500': v.errors[0] }"
                  />
                </div>
                <p
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                >
                  {{ v.errors[0] }}
                </p>
                <p
                v-if="!info.firstName" 
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                >
                 رجاء ادخال الاسم الاول فقط
                </p>
              </ValidationProvider>
            </div>

            <div>
              <label
                for="secondName"
                class="block text-lg font-bold leading-5 text-gray-900"
                >اسم الأب</label
              >
              <ValidationProvider
                name="secondName"
                rules="required|max:20|regex:^[\u0621-\u064A ]+$"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <input
                    v-model="info.secondName"
                    class="form-input py-3 px-4 block w-full transition ease-in-out duration-150"
                    :class="{ ' border border-red-500': v.errors[0] }"
                  />
                </div>
                <p
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                >
                  {{ v.errors[0] }}
                </p>
                <p
                v-if="!info.secondName" 
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                >
                 رجاء ادخال اسم الأب فقط
                </p>
              </ValidationProvider>
            </div>

            <div>
              <label
                for="thirdName"
                class="block text-lg font-bold leading-5 text-gray-900"
                >اسم الجد</label
              >
              <ValidationProvider
                name="thirdName"
                rules="required|max:20|regex:^[\u0621-\u064A ]+$"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <input
                    v-model="info.thirdName"
                    class="form-input py-3 px-4 block w-full transition ease-in-out duration-150"
                    :class="{ ' border border-red-500': v.errors[0] }"
                  />
                </div>
                <p
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                >
                  {{ v.errors[0] }}
                </p>
             
                <p
                v-if="!info.thirdName" 
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                >
                 رجاء ادخال اسم الجد فقط
                </p>
              </ValidationProvider>
            </div>

            <div>
              <label
                for="lastName"
                class="block text-lg font-bold leading-5 text-gray-900"
                >اللقب</label
              >
              <ValidationProvider
                name="lastName"
                rules="required|max:20|regex:^[\u0621-\u064A ]+$"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <input
                    v-model="info.lastName"
                    class="form-input py-3 px-4 block w-full transition ease-in-out duration-150"
                    :class="{ ' border border-red-500': v.errors[0] }"
                  />
                </div>
                <p
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                >
                  {{ v.errors[0] }}
                </p>
                <p
                v-if="!info.lastName" 
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                >
                 رجاء ادخال اسم اللقب فقط
                </p>
              </ValidationProvider>
            </div>


            <div class="sm:col-span-4">
              <label
                for="nid"
                class="block text-lg font-bold leading-5 text-gray-900"
                >الاسم الرباعي</label
              >

              
                <div class="mt-2 relative rounded-md shadow-sm">
                  <p
                    id="nid"
                    type="number"
                    class=" py-3 px-4 block w-full transition te ease-in-out duration-150 text-center"
                
                  >
                  <span v-if="info.firstName" > {{ info.firstName }} </span>
                  <span v-if="info.secondName" > {{ info.secondName }} </span>
                  <span v-if="info.thirdName" > {{ info.thirdName }} </span>
                  <span v-if="info.lastName" > {{ info.lastName }} </span>

               
                  </p>
                </div>
               
              
            </div>

            <div class="sm:col-span-4">
              <label
                for="nid"
                class="block text-lg font-bold leading-5 text-gray-900"
                >الرقم الوطني</label
              >

              <ValidationProvider
                name="nid"
                rules="required|digits:12|regex:^[1-2].*"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <input
                    id="nid"
                    v-model="info.nid"
                    type="number"
                    class="form-input py-3 px-4 block w-full transition te ease-in-out duration-150 text-center"
                    :class="{ ' border border-red-500': v.errors[0] }"
                  />
                </div>
                <p
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                  v-html="v.errors[0]"
                ></p>
              </ValidationProvider>
            </div>
            <!-- <div class="sm:col-span-4">
              <label
                for="familyBookid"
                class="block text-lg font-bold leading-5 text-gray-900"
              >
                رقم القيد</label
              >
              <ValidationProvider
                name="registration_number"
                rules="required"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <input
                    id="registration_number"
                    v-model="info.registration_number"
                    type="text"
                    class="form-input py-3 px-4 block w-full transition te ease-in-out duration-150 text-center"
                    :class="{ ' border border-red-500': v.errors[0] }"
                  />
                </div>
                <p 
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                  v-html="v.errors[0]"
                ></p>
              </ValidationProvider>
            </div> -->

            <div
              class="sm:col-span-4 mb-2 pt-8 border-t-2 mt-1"
              v-if="selectedmunicipality"
            >
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                بيانات الإقامة
              </h3>
              <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-400">
                الرّجاء إدخال البيانات وفقاً للسجلات الرّسمية
              </p>
            </div>
       

            <div class="sm:col-span-4" v-if="selectedmunicipality">
              <label
                for="package"
                class="block text-lg font-bold leading-5 text-gray-900"
                >الإقامة و القيد </label
              >
              <div class="mt-2 relative rounded-md shadow-sm">
                <select
                  id="type"
                  v-model="info.registration_type"
                  class="mt-1 form-select form-input block w-full pl-3 pr-10 py-3 px-4 text-lg leading-6 text-center border-gray-300 focus:outline-none focus:shadow-outline-primary focus:border-primary-300 sm:text-lg text-center"
                >
                  <option selected disabled :value="null">اختر</option>
                  <option selected :value="'registered_resident'">
                    مقيم و مقيد بمكاتب السجل المدني ب{{ selectedmunicipality.name }}
                  </option>
                  <option :value="'unregistered_resident'">
                    مقيم و غير مقيد بمكاتب السجل المدني ب{{ selectedmunicipality.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="sm:col-span-4 mb-2 pt-8 border-t-2 mt-1">
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                بيانات التواصل
              </h3>
              <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-400">
                لمراسلتك في حال وجود أي خطأ في البيانات التي قمت بإدخالها
              </p>
            </div>

            <div class="sm:col-span-4">
              <label
                for="mobile1"
                class="block text-lg font-bold leading-5 text-gray-900"
                >رقم الهاتف</label
              >
              <ValidationProvider
                name="mobile1"
                rules="required|regex:^09\d{8}$"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <input
                    v-model="info.mobile1"
                    type="number"
                    class="form-input py-3 px-4 block w-full transition te ease-in-out duration-150 text-center"
                    :class="{ ' border border-red-500': v.errors[0] }"
                  />
                </div>
                <p
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                >
                  {{ v.errors[0] }}
                </p>
              </ValidationProvider>
            </div>

            <!-- <div class="sm:col-span-4">
              <label
                for="package"
                class="block text-lg font-bold leading-5 text-gray-900"
                >حالة الاقامة</label
              >
              <div class="mt-2 relative rounded-md shadow-sm">
                <select
                  id="type"
                  v-model="info.citzen_type"
                  class="mt-1 form-select form-input block w-full pl-3 pr-10 py-3 px-4 text-lg leading-6 text-center border-gray-300 focus:outline-none focus:shadow-outline-primary focus:border-primary-300 sm:text-lg text-center"
                >
                  <option selected disabled>اختر</option>
                  <option value="1" class="font-bold">مقيم و مقيد</option>
                  <option value="2" class="font-bold">مقيم و غير مقيد</option>
                </select>
              </div>
            </div>

            <div class="sm:col-span-4" v-if="info.citzen_type == 2">
              <label
                for="package"
                class="block text-lg font-bold leading-5 text-gray-900"
                >نوع الاقامة</label
              >
              <div class="mt-2 relative rounded-md shadow-sm">
                <select
                  id="type"
                  v-model="info.type"
                  class="mt-1 form-select form-input block w-full pl-3 pr-10 py-3 px-4 text-lg leading-6 text-center border-gray-300 focus:outline-none focus:shadow-outline-primary focus:border-primary-300 sm:text-lg text-center"
                >
                  <option selected disabled>اختر</option>
                  <option value="" class="font-bold">دائم</option>
                  <option value="home" class="font-bold">مؤقتة</option>
                </select>
              </div>
            </div>

            <div class="sm:col-span-4" v-if="info.citzen_type == 2">
              <label
                for="package"
                class="block text-lg font-bold leading-5 text-gray-900"
                >سبب الاقامة</label
              >
              <div class="mt-2 relative rounded-md shadow-sm">
                <select
                  id="package"
                  v-model="info.reason"
                  class="mt-1 form-select form-input block w-full pl-3 pr-10 py-3 px-4 text-lg leading-6 text-center border-gray-300 focus:outline-none focus:shadow-outline-primary focus:border-primary-300 sm:text-lg"
                >
                  <option selected disabled>اختر</option>
                  <option value="1" class="font-bold">نازح</option>
                  <option value="2" class="font-bold">موظف</option>
                </select>
              </div>
            </div>

            <div class="sm:col-span-2" v-if="info.reason == 2">
              <label
                for="package"
                class="block text-lg font-bold leading-5 text-gray-900"
                >الوظيفة</label
              >
              <div class="mt-2 relative rounded-md shadow-sm">
                <input
                  id="father_name"
                  class="form-input py-3 px-4 block w-full transition ease-in-out duration-150"
                />
              </div>
            </div>

            <div class="sm:col-span-2" v-if="info.reason == 2">
              <label
                for="package"
                class="block text-lg font-bold leading-5 text-gray-900"
                >الجهة</label
              >
              <div class="mt-2 relative rounded-md shadow-sm">
                <input
                  id="father_name"
                  class="form-input py-3 px-4 block w-full transition ease-in-out duration-150"
                />
              </div>
            </div>

            <div class="sm:col-span-4" v-if="info.reason == 2">
              <label
                for="package"
                class="block text-lg font-bold leading-5 text-gray-900"
                >القطاع التابعة له جهة العمل</label
              >
              <div class="mt-2 relative rounded-md shadow-sm">
                <input
                  id="father_name"
                  class="form-input py-3 px-4 block w-full transition ease-in-out duration-150"
                />
              </div>
            </div> -->

            <!--
  Tailwind UI components require Tailwind CSS v1.8 and the @tailwindcss/ui plugin.
  Read the documentation to get started: https://tailwindui.com/documentation
-->

            <div
              class="sm:col-span-4 mt-2"
              v-if="(invalid && failed) || servererrors != null"
            >
              <div class="rounded-md bg-red-50 p-4">
                <div class="flex">
                  <div class="flex-shrink-0">
                    <!-- Heroicon name: x-circle -->
                    <svg
                      class="h-5 w-5 text-red-400"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                  <div class="mr-3">
                    <h3 class="text-base leading-5 font-medium text-red-500">
                      هناك أخطاء في إدخالك للحقول يجب معالجتها قبل الاستمرار
                    </h3>
                    <div
                      class="mt-2 text-base leading-5 text-red-700"
                      v-if="servererrors != null"
                    >
                      <ul class="list-disc pr-5">
                        <li class="mt-1">
                          {{ servererrors }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="sm:col-span-4 mt-1">
              <span class="w-full inline-flex rounded-md shadow-sm">
                <button
                  type="submit"
                  class="w-full inline-flex items-center justify-center px-6 py-3 border border-transparent text-lg leading-6 font-bold rounded-md text-white bg-primary-500 hover:bg-primary-500 font focus:outline-none focus:border-primary-700 focus:shadow-outline-primary active:bg-primary-700 transition ease-in-out duration-150"
                >
                  <svg
                    v-if="loading"
                    class="animate-spin -mr-1 ml-3 h-5 w-5 text-yellow-200"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      class="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4"
                    ></circle>
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>

                  التالي
                </button>
              </span>
            </div>
          </form>
        </ValidationObserver>
        <div
          class="block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all mb-12"
          role="dialog"
          v-else
        >
          <div>
            <div
              class="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100"
            >
              <!-- Heroicon name: check -->
              <svg
                class="h-10 w-10 text-green-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <div class="mt-4 text-center sm:mt-5">
              <h3 class="text-lg font-bold leading-10 text-gray-900">
                تم ارسال طلب تسجيلكم بنجاح
              </h3>
              <div class="mt-2">
                <p class="text-xl font-medium leading-7 text-gray-600">
                    سوف يتم ارسال رقمكم الانتخابي خلال <span class="systemfont font-bold"> 24 </span>  ساعة بعد إتمام التأكد من صحة البيانات التي تم إدخالها
                </p>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-6">
            <span class="flex w-full rounded-md shadow-sm">
              <router-link
                to="/enquiry"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-4 bg-primary-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-primary-400 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary transition ease-in-out duration-150 sm:text-sm sm:leading-5"
              >
               للإستفســار عن تسجيل
              </router-link>
            </span>
          </div>
          <!-- <div class="mt-5 sm:mt-6">
            <span class="flex w-full rounded-md shadow-sm">
              <router-link
                to="/"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-4 bg-primary-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-primary-400 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary transition ease-in-out duration-150 sm:text-sm sm:leading-5"
              >
                عودة للرئيسية
              </router-link>
            </span>
          </div> -->
        </div>
      </div>
    </div>
  </div>
  <div
    class="bg-cool-gray-50 py-4 px-4 overflow-hidden sm:px-6 lg:px-8 lg:py-12"
    v-else-if="page == 2"
  >
    <div class="relative max-w-xl mx-auto">
      <div class="mb-4">
        <img
          class="object-cover object-center rounded justify-center mx-auto w-48 mb-4"
          alt="hero"
          src=".././assets/ccme-logo.png"
        />
        <h3
          class="text-xl leading-9 tracking-tight font-bold text-primary-900 sm:text-3xl sm:leading-10 text-center"
        >
         مراجعة البيانات
        </h3>
      </div>



      <div class="pt-8 border-t-2 border-gray-300 mt-10">
        <ValidationObserver
          v-slot="{ handleSubmit,  invalid, failed }"
          v-if="!success"
        >
          <form
            @submit.prevent="handleSubmit(send)"
            class="grid grid-cols-1 row-gap-6 sm:grid-cols-4 sm:col-gap-8 text-right"
          >


            <div class="sm:col-span-4">
              <label
                for="package"
                class="block text-lg font-bold leading-5 text-gray-900"
                >البلدية</label
              >
              <ValidationProvider
                name="municipality"
                rules="required"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <select
                    id="type"
                   
                  style=" -o-appearance: none;
   -ms-appearance: none;
   -webkit-appearance: none;
   -moz-appearance: none;
   appearance: none;"
                    v-model="selectedmunicipality"
                    class="mt-1 block w-full  bg-transparent pl-3 pr-10 py-3 px-4 text-xl font-bold leading-6 text-center border-gray-300 focus:outline-none focus:shadow-outline-primary focus:border-primary-300 sm:text-lg"
                    :class="{ ' border border-red-500': v.errors[0] }"
                    disabled
                  >
                    <option selected disabled :value="null">اختر</option>
                    <option
                      v-for="municipality in municipalities"
                      :key="municipality.id"
                      :value="municipality"
                      class="font-bold"
                    >
                      {{ municipality.name }}
                    </option>
                  </select>
                </div>
                <p
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                  v-if="v.errors[0] != null"
                >
                  {{ v.errors[0] }}
                </p>
              </ValidationProvider>
            </div>

            <div class="sm:col-span-4" v-if="selectedmunicipality">
              <label
                for="package"
                class="block text-lg font-bold leading-5 text-gray-900"
                >مركز الاقتراع</label
              >
              <ValidationProvider
                name="electionCenterNo"
                rules="required"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <select
                  style=" -o-appearance: none;
   -ms-appearance: none;
   -webkit-appearance: none;
   -moz-appearance: none;
   appearance: none;"
                    v-model="info.electionCenterNo"
                    class="mt-1 systemfont font-bold bg-transparent block w-full pl-3 pr-10 py-3 px-4  text-xl font-bold  leading-6 text-center border-gray-300 focus:outline-none focus:shadow-outline-primary focus:border-primary-300 sm:text-lg"
                    :class="{ ' border border-red-500': v.errors[0] }"
                    disabled
                  >
                    <option selected disabled :value="null">اختر</option>
                    <option
                      v-for="center in selectedmunicipality.election_centers"
                      :key="center.id"
                      :value="center.id"
                      class="font-bold systemfont"
                    >
                      {{ center.name }}
                      <span class="systemfont"  
                        >- منطقة {{ center.area_name }}
                      </span>
                    </option>
                  </select>
                </div>
                <p
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                >
                  {{ v.errors[0] }}
                </p>
              </ValidationProvider>
            </div>


            <div class="sm:col-span-4">
              <label
                for="nid"
                class="block text-lg font-bold leading-5 text-gray-900"
                >الاسم الرباعي</label
              >

              
                <div class="mt-2 relative rounded-md shadow-sm">
                  <p
                    id="nid"
                    type="number"
                    class=" py-3 px-4 block w-full transition te ease-in-out duration-150 text-center  text-xl font-bold "
                
                  >
                  <span v-if="info.firstName" > {{ info.firstName }} </span>
                  <span v-if="info.secondName" > {{ info.secondName }} </span>
                  <span v-if="info.thirdName" > {{ info.thirdName }} </span>
                  <span v-if="info.lastName" > {{ info.lastName }} </span>

               
                  </p>
                </div>
               
              
            </div>

            <div class="sm:col-span-4">
              <label
                for="nid"
                class="block text-lg font-bold leading-5 text-gray-900"
                >الرقم الوطني</label
              >

              <ValidationProvider
                name="nid"
                rules="required|digits:12|regex:^[1-2].*"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <input
                    id="nid"
                    
                    disabled
                    v-model="info.nid"
                    type="number"
                    class="bg-transparent py-3 px-4 block w-full transition te ease-in-out duration-150 text-center  text-xl font-bold "
                    :class="{ ' border border-red-500': v.errors[0] }"
                  />
                </div>
                <p
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                  v-html="v.errors[0]"
                ></p>
              </ValidationProvider>
            </div>
            <!-- <div class="sm:col-span-4">
              <label
                for="familyBookid"
                class="block text-lg font-bold leading-5 text-gray-900"
              >
                رقم القيد</label
              >
              <ValidationProvider
                name="registration_number"
                rules="required"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <input
                    id="registration_number"
                    v-model="info.registration_number"
                    type="text"
                    class="form-input py-3 px-4 block w-full transition te ease-in-out duration-150 text-center"
                    :class="{ ' border border-red-500': v.errors[0] }"
                  />
                </div>
                <p 
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                  v-html="v.errors[0]"
                ></p>
              </ValidationProvider>
            </div> -->


       

            <div class="sm:col-span-4" v-if="selectedmunicipality">
              <label
                for="package"
                class="block text-lg font-bold leading-5 text-gray-900"
                >الإقامة و القيد </label
              >
              <div class="mt-2 relative rounded-md shadow-sm">
                <select
                  id="type"
                  style=" -o-appearance: none;
   -ms-appearance: none;
   -webkit-appearance: none;
   -moz-appearance: none;
   appearance: none;"
                  disabled
                  v-model="info.registration_type"
                  class="mt-1 bg-transparent block w-full pl-3 pr-10 py-3 px-4  text-xl font-bold  leading-6 text-center border-gray-300 focus:outline-none focus:shadow-outline-primary focus:border-primary-300 sm:text-lg  "
                >
                  <option selected disabled :value="null">اختر</option>
                  <option selected :value="'registered_resident'">
                    مقيم و مقيد بمكاتب السجل المدني ب{{ selectedmunicipality.name }}
                  </option>
                  <option :value="'unregistered_resident'">
                    مقيم و غير مقيد بمكاتب السجل المدني ب{{ selectedmunicipality.name }}
                  </option>
                </select>
              </div>
            </div>


            <div class="sm:col-span-4">
              <label
                for="mobile1"
                class="block text-lg font-bold leading-5 text-gray-900"
                >رقم الهاتف</label
              >
              <ValidationProvider
                name="mobile1"
                rules="required|regex:^09\d{8}$"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <input
                  disabled
                    v-model="info.mobile1"
                    type="number"
                    class="bg-transparent  py-3 px-4 block w-full transition te ease-in-out duration-150 text-center  text-xl font-bold "
                    :class="{ ' border border-red-500': v.errors[0] }"
                  />
                </div>
                <p
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                >
                  {{ v.errors[0] }}
                </p>
              </ValidationProvider>
            </div>


            <div class="sm:col-span-4 mt-2">
              <div class="rounded-md bg-yellow-50 p-4">
  <div class="flex">
 
    <div class="">
      <h3 class="text-base font-medium text-yellow-800 text-justify" >
        عزيزي الناخب تلتزم اللجنة المركزية لانتخابات  المجالس البلدية بحماية واحترام خصوصيتك، وسنتخذ دائما التدابير اللازمة لمنع الاستخدام غير المرخص لها وبمجرد تسجيلك في الانتخابات المجالس البلدية  عبر الموقع الاكتروني و تأكيد بأنك المستخدم الفعلي لبطاقة الهاتف والذي يكون وسيلة الاتصال الرسمية بالنسبة للجنة المركزية وسوف لن تتحمل اللجنة المركزية أية مسؤوليات عن سوء استخدام البيانات والمعلومات في حال تم الدخول للخدمة من قبل الغير ..</h3>
       
    </div>
  </div>
</div>



<div class="sm:col-span-4 mt-4">
              <span class="w-full inline-flex rounded-md shadow-sm">
                <a
               @click="gotopage(1)"
                  class="w-full inline-flex items-center justify-center px-6 py-3 border border-transparent text-lg leading-6 font-bold rounded-md text-gray-700 bg-gray-200 hover:bg-gray-200 font focus:outline-none focus:border-gray-700 focus:shadow-outline-gray active:bg-gray-300 transition ease-in-out duration-150"
                >
                  <svg
                    v-if="loading"
                    class="animate-spin -mr-1 ml-3 h-5 w-5 text-yellow-200"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      class="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4"
                    ></circle>
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>

                  عودة و تعديل البيانات
                </a>
              </span>
            </div>

<div
              class="sm:col-span-4 mt-4"
              v-if="(invalid && failed) || servererrors != null"
            >
              <div class="rounded-md bg-red-50 p-4">
                <div class="flex">
                  <div class="flex-shrink-0">
                    <!-- Heroicon name: x-circle -->
                    <svg
                      class="h-5 w-5 text-red-400"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                  <div class="mr-3">
                    <h3 class="text-base leading-5 font-medium text-red-500">
                      هناك أخطاء في إدخالك للحقول يجب معالجتها قبل الاستمرار
                    </h3>
                    <div
                      class="mt-2 text-base leading-5 text-red-700"
                      v-if="servererrors != null"
                    >
                      <ul class="list-disc pr-5">
                        <li class="mt-1">
                          {{ servererrors }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

              <span class="w-full inline-flex rounded-md shadow-sm mt-5">
                <button
                  type="submit"
                  class="w-full inline-flex items-center justify-center px-6 py-3 border border-transparent text-lg leading-6 font-bold rounded-md text-white bg-primary-500 hover:bg-primary-500 font focus:outline-none focus:border-primary-700 focus:shadow-outline-primary active:bg-primary-700 transition ease-in-out duration-150"
                >
                  <svg
                    v-if="loading"
                    class="animate-spin -mr-1 ml-3 h-5 w-5 text-yellow-200"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      class="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4"
                    ></circle>
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>

                  تأكيد وتسجيل
                </button>
              </span>
            </div>
          </form>
        </ValidationObserver>
        <div
          class="block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all mb-12"
          role="dialog"
          v-else
        >
          <div>
            <div
              class="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100"
            >
              <!-- Heroicon name: check -->
              <svg
                class="h-10 w-10 text-green-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <div class="mt-4 text-center sm:mt-5">
              <h3 class="text-lg font-bold leading-10 text-gray-900">
                تم ارسال طلب تسجيلكم بنجاح
              </h3>
              <div class="mt-2">
                <p class="text-xl font-medium leading-7 text-gray-600">
                    سوف يتم ارسال رقمكم الانتخابي خلال <span class="systemfont font-bold"> 24 </span>  ساعة بعد إتمام التأكد من صحة البيانات التي تم إدخالها
                </p>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-6">
            <span class="flex w-full rounded-md shadow-sm">
              <router-link
                to="/enquiry"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-4 bg-primary-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-primary-400 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary transition ease-in-out duration-150 sm:text-sm sm:leading-5"
              >
               للإستفســار عن تسجيل
              </router-link>
            </span>
          </div>
          <!-- <div class="mt-5 sm:mt-6">
            <span class="flex w-full rounded-md shadow-sm">
              <router-link
                to="/"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-4 bg-primary-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-primary-400 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary transition ease-in-out duration-150 sm:text-sm sm:leading-5"
              >
                عودة للرئيسية
              </router-link>
            </span>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      success: false,
      page:1,
      loading: false,
      selectedmunicipality: null,
      servererrors: null,
      info: {},
      cities: [
        {
          id: 1,
          name: "البيضاء",
        },
        {
          id: 2,
          name: "اجدابيا",
        },
        {
          id: 3,
          name: "بنغازي",
        },
      ],
      municipalities: [],
    };
  },
  methods: {
    gotopage(x){
   
      window.scrollTo(0,0);

      this.page=x;

   
    },
    reviewpage(){

      this.page=2;
    },

    send() {

      console.log(this.info);
      this.loading = true;



      this.info.registeredBy = "webapp";
      this.info.municipalId = this.selectedmunicipality.id;
      this.info.residence = this.selectedmunicipality.code;

      axios.post("mobile/voters", this.info).then(
        (response) => {
          console.log(response);
          if (response.status == 200) {
            this.success = true;
            this.loading = false;
          } else {
            this.servererrors = response.data.message;
            this.loading = false;
          }
        },
        (error) => {
          this.servererrors = error.response.data.message;
          this.loading = false;
        }
      );
    },
  },
  mounted() {
    axios.get("mobile/municipalities/").then(
      (response) => {
        console.log(response);
        if (response.status == 200) {
          this.municipalities = response.data.data;
        } else {
          this.servererrors = response.data.message;
        }
      },
      (error) => {
        this.servererrors = error.response.data.message;
      }
    );
  },
};
</script>
<style scoped>
input[type="number"] {
  -moz-appearance: textfield;
  direction: ltr;
}

input[type="email"] {
  direction: ltr;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.animate-spin {
  animation: spin 1s linear infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}
</style>